<template>
    <div class="opt">
        <el-dialog :title="!rowData ? '添加' : '编辑'" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="form">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" label-position="right">
                    <el-form-item label="标题：" prop="title">
                        <el-input v-model="ruleForm.title" clearable placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item label="发货人姓名：" prop="sender_name">
                        <el-input v-model="ruleForm.sender_name" clearable placeholder="请输入发货人姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="发货人电话：" prop="sender_cellphone">
                        <el-input v-model="ruleForm.sender_cellphone" clearable placeholder="发货人电话"></el-input>
                    </el-form-item>
                    <el-form-item label="地区：" prop="area">
                        <el-cascader
                            style="width: 100%"
                            clearable
                            v-model="ruleForm.area"
                            :options="city_list"
                            :props="{ expandTrigger: 'hover', label: 'ssqname', value: 'ssqid' }"
                            :show-all-levels="false"
                            @change="addChange"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址：" prop="address">
                        <el-input v-model="ruleForm.address" clearable placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit" :loading="btnLoad">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import address from "@/assets/address.js";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号"));
            } else {
                if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
                    callback(new Error("手机号码有误，请重填"));
                }
                callback();
            }
        };
        return {
            dialogVisible: false,
            ruleForm: {
                title: "",
                sender_name: "",
                sender_cellphone: "",
                area: [],
                areaStr: [],
                address: "",
            },
            rules: {
                title: [{ required: true, message: "请输入标题", trigger: "blur" }],
                sender_name: [{ required: true, message: "请输入发货人名称", trigger: "blur" }],
                sender_cellphone: [
                    { required: true, message: "请输入发货人电话", trigger: "blur" },
                    { validator: validatePhone, trigger: "blur" },
                ],
                area: [{ required: true, message: "请选择地区", trigger: "change" }],
                address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
            },
            city_list: [],
            address: address.province,
            rowData: null,
            btnLoad: false,
        };
    },
    mounted() {
        this.initAddress();
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            createWarehouse: "brand/createWarehouse",
            editWarehouse: "brand/editWarehouse",
        }),
        bindData(row) {
            this.rowData = JSON.parse(JSON.stringify(row));
            let { title, sender_name, sender_cellphone, address, city, city_code, district, district_code, province, province_code } = this.rowData;
            this.ruleForm = {
                title: title,
                sender_name: sender_name,
                sender_cellphone: sender_cellphone,
                area: [province_code, city_code, district_code],
                areaStr: [province, city, district],
                address: address,
            };
        },
        addChange(val) {
            this.ruleForm.areaStr = [];
            if (val.length > 0) {
                val.forEach((item) => {
                    this.ruleForm.areaStr.push(this.getItem(this.city_list, item));
                });
            }
        },
        getItem(list, id) {
            if (!list instanceof Array) {
                return null;
            }
            for (let i in list) {
                let item = list[i];
                if (item.ssqid === id) {
                    return item.ssqname;
                } else {
                    if (item.children) {
                        let value = this.getItem(item.children, id);
                        if (value) {
                            return value;
                        }
                    }
                }
            }
        },
        submit() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.btnLoad = true;
                    let { title, sender_name, sender_cellphone, area, areaStr, address } = this.ruleForm;
                    let params = {
                        token: this.getToken,
                        title: title,
                        sender_name: sender_name,
                        sender_cellphone: sender_cellphone,
                        province: areaStr[0],
                        city: areaStr[1],
                        district: areaStr[2],
                        province_code: area[0],
                        city_code: area[1],
                        district_code: area[2],
                        address: address,
                    };
                    let url;
                    if (!!this.rowData) {
                        params.id = this.rowData.id;
                        url = this.editWarehouse;
                    } else {
                        url = this.createWarehouse;
                    }
                    url(params).then(({ data }) => {
                        this.btnLoad = false;
                        if (data.code == 1) {
                            this.$message.success(`${this.rowData ? "修改" : "添加"} 成功！`);
                            this.$emit("init");
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        initAddress() {
            this.address.forEach((item) => {
                item.children = item.cities.city;
                if (item.cities.city && item.cities.city.length > 0) {
                    item.cities.city.forEach((v) => {
                        v.children = v.areas.area;
                    });
                }
            });
            this.city_list = this.address;
        },
        handleClose() {
            this.rowData = null;
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
                title: "",
                sender_name: "",
                sender_cellphone: "",
                area: [],
                areaStr: [],
                address: "",
            };
            this.btnLoad = false;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>